import { useSelector } from 'react-redux';

const useRegion = () => useSelector(state => state.regionsReducer.region);

const useRegions = () => useSelector(state => state.regionsReducer.regions);

const useLoading = () => useSelector(state => state.regionsReducer.loading);

export { useRegion, useRegions, useLoading };
